// Author Lin
// Date 2024-04-08 10:56:09

import * as model from "@/model/sithMes/mst/SithMesMstMaterialModel.js";
import {newEntityStoreHelper} from "@/store/common/entityModule";
import {customVuexFilterPatternFactory} from "@/store/em/commonPattern/customVuexFilterPatternFactory";
import {customVuexVoPatternFactory} from "@/store/em/commonPattern/customVuexVoPatternFactory";

function newFilter(paginationFilter = {}) {
    var filter = Object.assign({}, paginationFilter, model.filter)
    return filter;
}

export default newEntityStoreHelper(() => new model.SithMesMstMaterial(),newFilter)
    .withStates({
        baseModuleUrl: process.env.VUE_APP_SITHMES_MST_URL,
        callbackApi: process.env.VUE_APP_SITHMES_MST_URL + '/sithMesMstMaterial/workflow/complete-feedback',
        processDefinitionKey: "mst_material_maintain",
        processBusinessData: Object
    })
    .withMutations({
        setProcessBusinessData(state, data) {
            state.processBusinessData = data
        }
    })
    .withPatternFactory(customVuexFilterPatternFactory, {
        filterState: 'sithMesMstMaterialBasicFilter',
        filterInitializer: newFilter
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'editViewVo'
    })
    .withPatternFactory(customVuexVoPatternFactory, {
        voState: 'sithMesMstMaterialBasicVo'
    })
    .buildStore()
